import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { rem } from '../utilities/style';
import { colors } from '../theme/colors';
import { fontWeights } from '../theme/type';

import { ReactComponent as IconArrowRight } from '../images/icons/arrow-right.svg';
import Link from './Link';

const Arrow = styled(IconArrowRight)`
  flex-shrink: 0;
  display: inline-block;
  max-width: ${rem(18)};
  margin-left: ${rem(8)};
  opacity: 0;
  transform: translateX(${rem(-8)});
  transition: all .2s ease;
`;

const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => ['fillContainer'].indexOf(prop) === -1,
})`
  color: ${colors.blue['800']};
  font-size: ${rem(14)};
  font-weight: ${fontWeights.semiBold};
  text-decoration: underline;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: color .2s ease;

  ${({ fillContainer }) => fillContainer && `
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  `}

  &:hover {
    text-decoration: none;

    ${Arrow} {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const TextLink = ({ className, children, fillParent = false, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <StyledLink className={className} fillContainer={fillParent} {...rest}>
    {children}
    <Arrow aria-hidden="true" />
  </StyledLink>
);

TextLink.propTypes = {
  ...Link.propTypes,
  fillParent: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default styled(TextLink)();
